export default __webpack_public_path__ + "static/media/peppers-soul-surfers-slider.2a720280.jpg";